var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "caca" },
    [
      _c(
        "h2",
        [
          _c("v-icon", { staticClass: "mr-1", attrs: { color: "error" } }, [
            _vm._v("error")
          ]),
          _vm._v(_vm._s(_vm.$t("Payments.PNM.NotCompleted.Headline")))
        ],
        1
      ),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("div", [
            _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n    "),
            _vm.errorReference
              ? _c("div", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("Account.TransactionHistory.History.Reference")
                      ) +
                      ": \n      " +
                      _vm._s(_vm.errorReference) +
                      "\n    "
                  )
                ])
              : _vm._e()
          ])
        : _c("div", [
            _vm._v(_vm._s(_vm.$t("Payments.PNM.NotCompleted.Payment")))
          ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "goto__home" },
        [
          _c(
            "v-btn",
            {
              attrs: { large: "", color: "success" },
              on: {
                click: function($event) {
                  return _vm.goToHomepage()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Account.ChangePassword.GoToHomepage")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("NuveiEventDispatcher", { attrs: { paymentIsCompleted: false } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d2bd14e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d2bd14e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/Nuvei/NuveiPaymentFailed.vue
// module id = null
// module chunks = 